module.exports = __webpack_public_path__ + "static/media/userIcon.54a5e4f6.svg";